<template>
  <el-form
    ref="formRef"
    require-asterisk-position="right"
    label-position="top"
    :model="form"
  >
    <div v-for="(actor,index) in form.actorList" :key="actor.id" class="base-card-info c-auto">
      <div class="info-card-title flex items-center">
        {{ `${actor.actorId}（${actorTypeConfig[actor.actorType]}-${ platformConfig[actor.platform] }）` }}
        <div class="w-[439px]">
          <el-form-item
            class="mb-0"
            :prop="'actorList.'+index+'.actorName'"
            :rules="{
              required: true, message: `${actorTypeConfig[actor.actorType]}名称不能为空`, trigger: 'blur'
            }"
          >
            <el-select
              v-model="form.actorList[index].actorName"
              filterable
              clearable
              :placeholder="`${actorTypeConfig[actor.actorType]}名称`"
              :disabled="from=='agent'&&actor.platform==EPlatform.SAAS"
              remote
              :remote-method="($event) => remoteMethod($event,actor,index)"
              @change="handleChange($event,index)"
            >
              <el-option
                v-for="item in optionsList[index]"
                :key="item.actorName"
                :label="item.actorName"
                :value="item.actorName"
              >
                {{ item.actorName }}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div v-if="from === 'saas' || from === 'server'" class="label">
        <el-form-item
          label="签署要求"
          :prop="'actorList.'+index+'.autoSign'"
          :rules="{
            required: true, message: '签署要求不能为空', trigger: 'blur'
          }"
        >
          <div class="tip">
            <el-popover
              width="353"
              placement="right"
              trigger="hover"
            >
              <template #reference>
                <svg-icon class="!w-[14px] ml-[15px] main-primary-text" icon="mingcute:warning-line" />
              </template>
              <div class="text-[##6B7891]">
                签署要求：<br>
                1.自动签署：对应签署方会自动签署合同，对应用户为无感签约<br>
                2.手动签约：用户需要登录系统手动签署合同
              </div>
            </el-popover>
          </div>
          <el-radio-group v-model="form.actorList[index].autoSign">
            <el-radio :label="autoSignConfig[EAutoSign.AUTO_SIGN]" :value="EAutoSign.AUTO_SIGN" />
            <el-radio :label="autoSignConfig[EAutoSign.MANUALLY_SIGN]" :value="EAutoSign.MANUALLY_SIGN" />
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="actor.contractFieldList" class="flex">
        <div class="oa-form-left">
          <div v-for="(fieldItem,index1) in actor.contractFieldList" :key="fieldItem.fieldCode">
            <el-form-item
              v-if="index1%2==0"
              :label="fieldItem.field"
              :prop="'actorList.'+index+'.contractFieldList.'+index1+'.fieldValue'"
              :rules="{
                required: fieldItem.requiredField==1, message: fieldItem.field+'不能为空', trigger: 'blur'
              }"
            >
              <el-input
                v-model="form.actorList[index].contractFieldList[index1].fieldValue"
                clearable
                autocomplete="nony"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </div>
        <div class="oa-form-right">
          <div v-for="(fieldItem,index1) in actor.contractFieldList" :key="fieldItem.fieldCode">
            <el-form-item
              v-if="index1%2==1"
              :prop="'actorList.'+index+'.contractFieldList.'+index1+'.fieldValue'"
              :label="fieldItem.field"
              :rules="{
                required: fieldItem.requiredField==1, message: fieldItem.field+'不能为空', trigger: 'blur'
              }"
            >
              <el-input
                v-model="form.actorList[index].contractFieldList[index1].fieldValue"
                clearable
                autocomplete="nony"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from 'vue';
import { SvgIcon } from '@vue3/components';
import { queryContractCreateDropDownActor, queryContractCreateFindSysValue } from '../../../../..';
import { ElMessage } from 'element-plus';
import { autoSignConfig, EAutoSign, IContractFreeDetailVO, actorTypeConfig, platformConfig, IContractSysValueDTO, EPlatform } from '../../../../../types/contracts/contracts';
import { isNull } from '@core/tools';

const props = defineProps({
  data: {
    type: Object as PropType<IContractFreeDetailVO>,
    default: () => {
      return {} as IContractFreeDetailVO;
    },
  },
  enableEnterKey: {
    type: Boolean,
    default: true,
  },
  /** 自动滚动到错误位置 */
  autoScrollToError: {
    type: Boolean,
    default: true,
  },
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
});

const form = ref({ actorList: props.data.actorVoList });
const optionsList = ref([]);
const allOptionsList = ref([]);
const formRef = ref();

async function remoteMethod(keyword: string, actor: any, index: any) {
  if (!allOptionsList.value[index]) {
    try {
      const res = await queryContractCreateDropDownActor({
        actorType: actor.actorType,
        platform: actor.platform,
      });

      allOptionsList.value[index] = res;

      optionsList.value[index] = allOptionsList.value[index].filter((item) => {
        return item.actorName.toLowerCase()
          .indexOf(keyword.toLowerCase()) > -1;
      });
    } catch (error) {
      if ((error as Error).message) ElMessage.error((error as Error).message);
    }
  } else {
    optionsList.value[index] = allOptionsList.value[index].filter((item) => {
      return item.actorName.toLowerCase()
        .indexOf(keyword.toLowerCase()) > -1;
    });
  }
}

function handleChange(value, index) {
  const option = optionsList.value[index].filter((item) => item.actorName == value);

  form.value.actorList[index].actorName = option[0].actorName;
  form.value.actorList[index].platformId = option[0]?.platformId;

  let params = {
    actorConfigId: Number(form.value.actorList[index].id),
    platformId: option[0].platformId,
    platform: props.data.actorVoList[index].platform,
  };

  queryContractCreateFindSys(params, index);
}

async function queryContractCreateFindSys(params: IContractSysValueDTO, index: any) {
  try {
    const res = await queryContractCreateFindSysValue(params);
    let arr = {};

    if (res?.length > 0) {
      res.forEach((item) => {
        arr[item.fieldCode] = item;
      });

      form.value.actorList[index].contractFieldList.map((field) => {
        field.fieldValue = arr[field.fieldCode].fieldValue;
      });
    }
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function initForm() {
  form.value = { actorList: props.data.actorVoList };
  allOptionsList.value = [];
}

async function validate(callback?: () => void) {
  let valid = false;

  if (!formRef.value) return valid;

  await formRef.value.validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    }
  });

  return valid;
}

function resetFormValues() {

  formRef.value?.resetFields?.();
}

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => form.value,
  /** 表单数据重置（base props.data） */
  reset: resetFormValues,
});

watch(
  () => props.data,
  () => {
    if (!isNull(props.data)) {
      initForm();
    }
  },
);
</script>

<style lang="scss" scoped>
.oa-form-left {
  width: 432px;
}

.oa-form-right {
  width: 432px;
  margin-left: 114px;
}

.label {
  position: relative;

  & .tip {
    position: absolute;
    top: -30px;
    left: 60px;

  }
}
</style>
